import MediaControl from './media_control'
export default MediaControl



// WEBPACK FOOTER //
// ./src/components/media_control/index.js